import React from 'react';
import { Button, Space, Typography } from 'antd';

const { Text } = Typography;

const ActionButtons = ({
  isEditing,
  analysisComplete,
  extractedData,
  supplierAdded,
  productsAdded,
  addingSupplier,
  addingProducts,
  onProceedToAnalysis,
  onAddSupplier,
  onAddProducts,
  onUseExtractedData,
  onRetry
}) => {
  if (isEditing) return null;

  return (
    <div style={{ textAlign: 'center', marginTop: 24 }}>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {!analysisComplete ? (
          // Initial proceed button
          <div>
            <Button 
              type="primary" 
              onClick={onProceedToAnalysis}
              style={{ width: '200px' }}
              size="large"
            >
              Proceed to Analysis
            </Button>
            <div style={{ marginTop: 8, fontSize: '12px', color: '#666' }}>
              System will check for new suppliers and products
            </div>
          </div>
        ) : (
          // After analysis - show add buttons and use data
          <>
            {/* Add Supplier Button */}
            {extractedData.newSuppliers && extractedData.newSuppliers.length > 0 && !supplierAdded && (
              <Button 
                type="primary" 
                loading={addingSupplier}
                onClick={onAddSupplier}
                style={{ width: '200px' }}
              >
                Add Supplier
              </Button>
            )}
            
            {/* Add Products Button */}
            {extractedData.newProducts && extractedData.newProducts.length > 0 && !productsAdded && (
              <Button 
                type="primary" 
                loading={addingProducts}
                onClick={onAddProducts}
                style={{ width: '200px' }}
              >
                Add Products ({extractedData.newProducts.length})
              </Button>
            )}
            
            {/* Use This Data Button */}
            <div>
              <Button 
                type="primary" 
                onClick={onUseExtractedData}
                disabled={
                  (extractedData.newSuppliers?.length > 0 && !supplierAdded) ||
                  (extractedData.newProducts?.length > 0 && !productsAdded)
                }
                style={{ width: '200px' }}
              >
                Use This Data
              </Button>
              {((extractedData.newSuppliers?.length > 0 && !supplierAdded) ||
                (extractedData.newProducts?.length > 0 && !productsAdded)) && (
                <div style={{ marginTop: 8, fontSize: '12px', color: '#999' }}>
                  Please add suppliers and products first
                </div>
              )}
            </div>
          </>
        )}
        
        <Button onClick={onRetry}>
          Analyze Again
        </Button>
      </Space>
    </div>
  );
};

export default ActionButtons;
